import React from 'react'

import './hero.css'
import WaveMulti from './wavemulti.js'
import { contentfulImageSrcSet, contentfulImageUrl } from '../lib/contentful-image'

// import HeroBg from '../../images/hero/hero-bg.jpg'
// import YoyoBg from '../../images/hero/yoyo-bg.jpg'
// import NotFoundBg from '../../images/hero/404-bg.jpg'


class Hero extends React.PureComponent {
    state = { backgroundReady: false }

    componentDidMount() {
        const speed = 1

        let hero = document.getElementById("Hero")
        let bg = hero.firstElementChild
        let text = hero.firstElementChild.nextElementSibling.firstElementChild

        this.hero = hero
        this.handleMouseMove = (e) => {
            this.pointerX = e.pageX
            this.pointerY = e.pageY

            if (this.animationFrame) return

            this.animationFrame = window.requestAnimationFrame(() => {
                let x = (window.innerWidth - this.pointerX * speed) / 100
                let y = (window.innerHeight - this.pointerY * speed) / 100

                bg.style.transform = `scale(1.1) translateX(${x}px) translateY(${y}px)`
                text.style.transform = `translateX(${-x}px) translateY(${-y}px)`
                this.animationFrame = null
            })
        }
        hero.addEventListener('mousemove', this.handleMouseMove, { passive: true })

        if (this.backgroundImage && this.backgroundImage.complete && this.backgroundImage.naturalWidth) {
            this.handleBackgroundLoad()
        }
    }

    handleBackgroundLoad = () => {
        if (this.state.backgroundReady || this.backgroundReadyScheduled) {
            return
        }

        this.backgroundReadyScheduled = true
        const revealText = () => {
            if (this.unmounted) {
                return
            }
            this.backgroundPaintFrame = window.requestAnimationFrame(() => {
                this.textRevealFrame = window.requestAnimationFrame(() => {
                    if (!this.unmounted) {
                        this.setState({ backgroundReady: true })
                    }
                })
            })
        }

        if (this.backgroundImage.decode) {
            this.backgroundImage.decode().then(revealText, revealText)
        } else {
            revealText()
        }
    }

    componentWillUnmount() {
        this.unmounted = true
        if (this.hero && this.handleMouseMove) {
            this.hero.removeEventListener('mousemove', this.handleMouseMove)
        }
        if (this.animationFrame) {
            window.cancelAnimationFrame(this.animationFrame)
        }
        if (this.backgroundPaintFrame) {
            window.cancelAnimationFrame(this.backgroundPaintFrame)
        }
        if (this.textRevealFrame) {
            window.cancelAnimationFrame(this.textRevealFrame)
        }
    }

    render() {
        // Pages can enlarge the copy without changing the shared Hero defaults.
        const { textScale = 1, mobileTextScale = textScale } = this.props
        const image = this.props.data[0].node.bg.fluid.src
        const imageSrc = contentfulImageUrl(image, 960, 45)
        const imageSrcSet = contentfulImageSrcSet(image, [480, 640, 960, 1280], 45)

        return (
            // <div className="Hero" style={{ backgroundImage: `url(${this.props.data.bg.fluid.src})` }} loading="eager">
            <div
                className={textScale !== 1 || mobileTextScale !== 1 ? 'Hero HeroTextScaled' : 'Hero'}
                id="Hero"
                style={{ '--hero-text-scale': textScale, '--hero-mobile-text-scale': mobileTextScale }}
            >
            {/* <div className="Hero" style={{ backgroundImage: `url(${ this.state.pageBg })` }} loading="eager"> */}
                <img
                    className="HeroBG"
                    src={imageSrc}
                    srcSet={imageSrcSet}
                    sizes="100vw"
                    loading="eager"
                    decoding="async"
                    fetchpriority="high"
                    alt=""
                    draggable="false"
                    ref={element => { this.backgroundImage = element }}
                    onLoad={this.handleBackgroundLoad}
                />
                <div className="HeroGroup">
                    <div className={this.state.backgroundReady ? 'HeroTextGroup HeroTextReady' : 'HeroTextGroup'}>
                        <h1>{this.props.data[0].node.name}</h1>
                        <h3>{this.props.data[0].node.description}</h3>
                        <blockquote>{this.props.data[0].node.quote}</blockquote>
                    </div>
                </div>
                <WaveMulti />
            </div>
        )
    }
}

export default Hero
